import React from 'react'
import Avatar from '@material-ui/core/Avatar'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  avatar: {
    marginRight: '40px',
    width: '76px',
    height: '76px',
  },
  avatarIcon: {
    width: '42px',
    height: '42px',
  },
  listItem: {
    padding: '0 40px 40px 0',
  },
}))

const HowAvatar = ({ icon: Icon, color, alt, colorClass }) => {
  const classes = useStyles()
  const isString = typeof Icon === 'string'
  return (
    <Avatar
      className={clsx(classes.avatar, colorClass)}
      style={{ background: color }}
    >
      {isString ? (
        <img src={Icon} alt={alt} className={classes.avatarIcon} />
      ) : (
        <Icon className={classes.avatarIcon} />
      )}
    </Avatar>
  )
}

const HowListItem = ({ title, children, icon }) => {
  const classes = useStyles()
  return (
    <ListItem className={classes.listItem}>
      <ListItemAvatar>{icon}</ListItemAvatar>
      <ListItemText
        primary={
          <Typography variant="h5" gutterBottom>
            {title}
          </Typography>
        }
        secondary={
          <Typography variant="body2" style={{ color: '#000000' }}>
            {children}
          </Typography>
        }
      />
    </ListItem>
  )
}

export const HowSectionList = ({ data }) => {
  return (
    <List>
      {data.map(({ title, icon, text, iconBg }) => (
        <HowListItem
          key={title}
          title={title}
          icon={<HowAvatar icon={icon} colorClass={iconBg} />}
        >
          {text}
        </HowListItem>
      ))}
    </List>
  )
}

HowSectionList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      text: PropTypes.string,
      icon: PropTypes.any,
      iconBg: PropTypes.string,
    }),
  ),
}
